import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { JurisdictionService } from 'src/app/services/geo/jurisdiction.service';
import { toBoolean } from 'src/app/services/codeUtils';
import { LocationWarningService } from 'src/app/services/location-warning/location-warning.service';

@Component({
    selector: 'app-signup-result',
    templateUrl: './signup-result.component.html',
    styleUrls: ['./signup-result.component.scss'],
})
export class SignupResultComponent implements OnInit {


    public wasSuccessful: boolean = true;
    public responsibleGamingNumber: string;
    afterSuccessfulRegistration: boolean;

    constructor(
        protected config: ConfigService,
        protected userSessionService: UserSessionService,
        protected utils: UtilsService,
        private eventsService: EventsService,
        private lobbyService: LobbyService,
        private navigator: Navigator,
        public authenticationService: AuthenticationService,
        private jurisdiction: JurisdictionService,
        private locationWarningService: LocationWarningService
    ) { }

    ngOnInit(): void {
        this.responsibleGamingNumber = this.config.getConfig().RESPONSIBLE_GAMING_NUMBER ?? '1-800-522-4700';
        this.afterSuccessfulRegistration = this.config.getConfig().FEATURE_LOCATION_WARNING_AFTER_REGISTERATION === "1" ? true : false;
        this.eventsService.publish('event:lobby:show');
    }

    ionViewCanLeave() {
        localStorage.setItem('MFA.signup', 'false');
    }

    closeSuccessModal = () => {
        setTimeout(() => {
            this.activateCustomer();
        }, 500);
    }

    protected openPage(page) {
        return this.navigator.navigateTo(page, { multipleModals: true }, { previousPage: "SignupResult" });
    }

    protected redirectUserToLobby(): void {
        //this.appActions.redirectAfterSuccessfulRegistration();
        this.eventsService.publish("event:login", {
            customer_id: this.userSessionService.getCustomerId(),
        });

        //const pageName = this.config.getExternalLinks().payload.filter(link => link?.code == "homepage")[0]?.url;
        this.eventsService.publish('action:changeTab', 'casino');
    }

    private activateCustomer = () => {
        localStorage.setItem('MFA.signup', 'false');
        this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {
            this.lobbyService.setCurrentLoginTime(customer.currentLoginTime);
            /*setTimeout(()=> {
                this.bannerProvider.fetchAllBanners();
            }, 2000);*/


            this.userSessionService.setUserStatus({
                customerId: this.userSessionService.getCustomerId(),
                sessionToken: this.userSessionService.getSessionToken()
            })
        });


		const config = this.config.getConfig();
		const geoAfterLoginFlag: boolean = this.config.isFeatureON( config, 'FEATURE_GEOLOCATION_ENFORCED_ON_LOGIN', true);

        if (this.afterSuccessfulRegistration && this.locationWarningService.locationIsAllowed() === false) {
            setTimeout(() => {
                this.locationWarningService.openLocationWarning('register', {});
            }, 1000);
        } else {
            if (geoAfterLoginFlag) {
                this.addGeo();
            }
        }

        this.redirectUserToLobby();

        this.eventsService.publish("event:notifications:start");
    }

    private addGeo = () => {
        this.jurisdiction
            .verifyJurisdiction(() => { })
            .then((geoResp: GeoResponse) => {
                console.log('Signup Result geo check');
            })
            .catch((err) => {
                console.log("Signup Result: launch aborted.", err);
            });
    }

}
